import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzDividerComponent],
  templateUrl: './terms-conditions.component.html',
  styleUrls: ["./terms.conditions.scss"],
})
export class TermsConditionsComponent {
  urlIMG = environment.urlIMG;
  terms = [
    {
      header: 'terms heading 1',
      points: [
        {
          header: 'terms subheading 1.1',
          text: 'terms point 1.1',
        },
        {
          header: 'terms subheading 1.2',
          text: 'terms point 1.2',
        },
      ],
    },
    {
      header: 'terms heading 2',
      points: [
        {
          header: 'terms subheading 2.1',
          text: 'terms point 2.1',
        },
        {
          header: 'terms subheading 2.2',
          text: 'terms point 2.2',
        },
        {
          header: 'terms subheading 2.3',
          text: 'terms point 2.3',
        },
        {
          header: 'terms subheading 2.4',
          text: 'terms point 2.4',
        },
        {
          header: 'terms subheading 2.5',
          text: 'terms point 2.5',
        },
        {
          header: 'terms subheading 2.6',
          text: 'terms point 2.6',
        },
        {
          header: 'terms subheading 2.7',
          text: 'terms point 2.7',
        },
        {
          header: 'terms subheading 2.8',
          text: 'terms point 2.8',
        },
        {
          header: 'terms subheading 2.9',
          text: 'terms point 2.9',
        },
        {
          header: 'terms subheading 2.10',
          text: 'terms point 2.10',
        },
        {
          header: 'terms subheading 2.11',
          text: 'terms point 2.11',
        },
        {
          header: 'terms subheading 2.12',
          text: 'terms point 2.12',
        },
      ],
    },
    {
      header: 'terms heading 3',
      points: [
        {
          header: 'terms subheading 3.1',
          text: 'terms point 3.1',
        },
        {
          header: 'terms subheading 3.2',
          text: 'terms point 3.2',
        },
      ],
    },
    {
      header: 'terms heading 4',
      points: [
        {
          header: 'terms subheading 4.1',
          text: 'terms point 4.1',
        },
        {
          header: 'terms subheading 4.2',
          text: 'terms point 4.2',
        },
        {
          header: 'terms subheading 4.3',
          text: 'terms point 4.3',
        },
      ],
    },
    {
      header: 'terms heading 5',
      points: [
        {
          header: 'terms subheading 5.1',
          text: 'terms point 5.1',
        },
        {
          header: 'terms subheading 5.2',
          text: 'terms point 5.2',
        },
      ],
    },
    {
      header: 'terms heading 6',
      points: [
        {
          header: 'terms subheading 6.1',
          text: 'terms point 6.1',
        },
        {
          header: 'terms subheading 6.2',
          text: 'terms point 6.2',
        },
        {
          header: 'terms subheading 6.3',
          text: 'terms point 6.3',
        },
        {
          header: 'terms subheading 6.4',
          text: 'terms point 6.4',
        },
        {
          header: 'terms subheading 6.5',
          text: 'terms point 6.5',
        },
        {
          header: 'terms subheading 6.6',
          text: 'terms point 6.6',
        },
      ],
    },
    {
      header: 'terms heading 7',
      points: [
        {
          header: 'terms subheading 7.1',
          text: 'terms point 7.1',
        },
        {
          header: 'terms subheading 7.2',
          text: 'terms point 7.2',
        },
        {
          header: 'terms subheading 7.3',
          text: 'terms point 7.3',
        },
      ],
    },
    {
      header: 'terms heading 8',
      points: [
        {
          header: 'terms subheading 8.1',
          text: 'terms point 8.1',
        },
      ],
    },
    {
      header: 'terms heading 9',
      points: [
        {
          header: 'terms subheading 9.1',
          text: 'terms point 9.1',
        },
      ],
    },
    {
      header: 'terms heading 10',
      points: [
        {
          header: 'terms subheading 10.1',
          text: 'terms point 10.1',
        },
      ],
    },
    {
      header: 'terms heading 11',
      points: [
        {
          header: 'terms subheading 11.1',
          text: 'terms point 11.1',
        },
        {
          header: 'terms subheading 11.2',
          text: 'terms point 11.2',
        },
        {
          header: 'terms subheading 11.3',
          text: 'terms point 11.3',
        },
      ],
    },
    {
      header: 'terms heading 12',
      points: [
        {
          header: 'terms subheading 12.1',
          text: 'terms point 12.1',
        },
        {
          header: 'terms subheading 12.2',
          text: 'terms point 12.2',
        },
      ],
    },
  ];

  constructor() {}
}
